// CHARTER — booking + bureau contact. Two-pane: left bureau panel, right form.
// NO marquee. NO carousel. NO grid of cards. Distinctive: form labels are *footnoted*.
export default function Charter() {
  return (
    <div className="bg-[#0A1F2E] text-[#E8DDC7]">
      <section className="pt-32 pb-16 max-w-[1440px] mx-auto px-8 lg:px-14">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B68F4E] mb-4">— Chapter 04 / The Bureau</p>
        <h1 className="font-serif text-[56px] lg:text-[120px] leading-[0.88] tracking-[-0.025em] max-w-5xl">Tell us a little. <span className="italic text-[#B68F4E]">We answer in person</span>.</h1>
      </section>

      <section className="max-w-[1440px] mx-auto px-8 lg:px-14 pb-32 grid lg:grid-cols-[1fr_1.4fr] gap-12 lg:gap-20">
        {/* Bureau panel */}
        <div>
          <div className="border border-[#E8DDC7]/15 p-8 lg:p-10 bg-[#06151E]">
            <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B68F4E] mb-3">Bureau Antibes</p>
            <p className="font-serif text-3xl mb-6">Quai Antoine 1<sup className="text-[#B68F4E] text-base">er</sup></p>
            <div className="space-y-3 text-sm text-[#E8DDC7]/70">
              <p>06600 Antibes, France</p>
              <p>+33 4 93 11 04 60</p>
              <p className="text-[#B68F4E]">bureau@avalonmaison.com</p>
            </div>
            <div className="border-t border-[#E8DDC7]/15 mt-8 pt-6">
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B68F4E] mb-3">Office hours</p>
              <table className="w-full font-mono text-[11px]">
                <tbody>
                  {[['Mon — Fri', '09:00 — 19:00 CET'], ['Saturday', 'By appointment'], ['Charter season', 'Bureau open daily']].map(([d, h]) => (
                    <tr key={d}><td className="py-1.5 text-[#E8DDC7]/55 uppercase tracking-[0.15em]">{d}</td><td className="py-1.5 text-right">{h}</td></tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <p className="text-sm text-[#E8DDC7]/55 leading-[1.7] mt-8">A bureau director will telephone you within twenty-four hours of receipt &mdash; usually less. We do not staff a contact-centre. We pick up the line.</p>
        </div>

        {/* Form — distinctive: every input has a small footnoted hint */}
        <form className="space-y-9" onSubmit={(e) => e.preventDefault()}>
          <Field label="Your name" hint="As we should address you in correspondence." testId="yacht-charter-name" />
          <div className="grid sm:grid-cols-2 gap-9">
            <Field label="Telephone" hint="Direct line. We call before we write." testId="yacht-charter-tel" type="tel" />
            <Field label="Email" hint="Discreet inboxes only, please." testId="yacht-charter-email" type="email" />
          </div>
          <div className="grid sm:grid-cols-2 gap-9">
            <SelectField label="Class of yacht" hint="Sail, motor, or explorer. Or unsure." options={['No preference', 'Sailing', 'Motor', 'Explorer']} testId="yacht-charter-class" />
            <SelectField label="Cruising area" hint="Where you would like to be." options={['Western Mediterranean', 'Eastern Mediterranean', 'Caribbean', 'Polar (explorer only)', 'Other']} testId="yacht-charter-area" />
          </div>
          <div className="grid sm:grid-cols-2 gap-9">
            <Field label="Approximate dates" hint="Two-week window suffices at this stage." />
            <Field label="Number of guests" hint="Including any children. Crew not counted." type="number" />
          </div>
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B68F4E] mb-2">Anything else <sup>1</sup></p>
            <textarea rows="4" className="w-full bg-transparent border-b border-[#E8DDC7]/30 py-3 outline-none focus:border-[#B68F4E] resize-none text-base text-[#E8DDC7] placeholder:text-[#E8DDC7]/30" placeholder="Particular ports, dietary notes, the captain you have sailed with before…" />
            <p className="font-mono text-[10px] text-[#E8DDC7]/45 mt-2"><sup>1</sup> Including any sensitivities. Discretion is presumed.</p>
          </div>
          <button type="button" data-testid="yacht-charter-submit" className="bg-[#B68F4E] text-[#0A1F2E] px-9 py-4 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#E8DDC7] transition-colors">Send to the bureau →</button>
        </form>
      </section>
    </div>
  );
}

function Field({ label, hint, type = 'text', testId }) {
  return (
    <div>
      <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B68F4E] block mb-2">{label}</label>
      <input data-testid={testId} type={type} className="w-full bg-transparent border-b border-[#E8DDC7]/30 py-3 outline-none focus:border-[#B68F4E] text-base text-[#E8DDC7]" />
      <p className="font-mono text-[10px] text-[#E8DDC7]/45 mt-2">{hint}</p>
    </div>
  );
}
function SelectField({ label, hint, options, testId }) {
  return (
    <div>
      <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B68F4E] block mb-2">{label}</label>
      <select data-testid={testId} className="w-full bg-transparent border-b border-[#E8DDC7]/30 py-3 outline-none focus:border-[#B68F4E] text-base text-[#E8DDC7]">
        {options.map(o => <option key={o} className="bg-[#0A1F2E]">{o}</option>)}
      </select>
      <p className="font-mono text-[10px] text-[#E8DDC7]/45 mt-2">{hint}</p>
    </div>
  );
}
